// extracted by mini-css-extract-plugin
export default {"menuIcon":"GroupMenu_menuIcon__qfDWb","deleteItem":"GroupMenu_deleteItem__MCdp0"};